"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeMarked = exports.DeMarkedTokenizerError = exports.DeMarked = void 0;
const demarked_1 = require("@d24/demarked");
Object.defineProperty(exports, "DeMarked", { enumerable: true, get: function () { return demarked_1.DeMarked; } });
Object.defineProperty(exports, "DeMarkedTokenizerError", { enumerable: true, get: function () { return demarked_1.TokenizerError; } });
const SimpleModuleAdapter_1 = require("./SimpleModuleAdapter");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.createDeMarked = () => {
    const storage = demarked_1.storageFactory();
    return new demarked_1.DeMarked(new SimpleModuleAdapter_1.SimpleModuleAdapter(), storage, { errorHandlingPolicy: demarked_1.ErrorHandlingPolicy.CatchAndError });
};
//# sourceMappingURL=index.js.map